import "./init";
import "./webview-bridge";
import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import PageLoading from "./components/PageLoading";
import TabBar, { IPosition } from "@/components/TabBar";
import "./assets/styles/antd-reset.scss";

const Account = lazy(
  () => import(/* webpackChunkName: "Account" */ "./pages/Account")
);
const Account3 = lazy(
  () => import(/* webpackChunkName: "Account3" */ "./pages/Account3")
);
const ACAccount = lazy(
  () => import(/* webpackChunkName: "Account" */ "./pages/ACAccount")
);
const Redpacket = lazy(
  () => import(/* webpackChunkName: "Redpacket" */ "./pages/Redpacket")
);
const Redpacket3 = lazy(
  () => import(/* webpackChunkName: "Redpacket3" */ "./pages/Redpacket3")
);
const Share = lazy(
  () => import(/* webpackChunkName: "Share" */ "./pages/Share")
);
const Gift = lazy(() => import(/* webpackChunkName: "Gift" */ "./pages/Gift"));

const Rank = lazy(() => import(/* webpackChunkName: "Rank" */ "./pages/Rank"));

const Agreement = lazy(
  () => import(/* webpackChunkName: "Agreement" */ "./pages/Agreement")
);

const Privacy = lazy(
  () => import(/* webpackChunkName: "Privacy" */ "./pages/Privacy")
);

const Children = lazy(
  () => import(/* webpackChunkName: "Children" */ "./pages/Children")
);

const ThreeShare = lazy(
  () => import(/* webpackChunkName: "ThreeShare" */ "./pages/ThreeShare")
);

const Community = lazy(
  () => import(/* webpackChunkName: "Community" */ "./pages/Community")
);

const More = lazy(() => import(/* webpackChunkName: "More" */ "./pages/More"));

const Services = lazy(
  () => import(/* webpackChunkName: "Services" */ "./pages/Services")
);

const ServicesQiyu = lazy(
  () => import(/* webpackChunkName: "ServicesQiyu" */ "./pages/Services/Qiyu")
);

const Faq = lazy(
  () => import(/* webpackChunkName: "Faq" */ "./pages/Services/Faq")
);

const FaqFeedback = lazy(
  () =>
    import(/* webpackChunkName: "FaqFeedback" */ "./pages/Services/FaqFeedback")
);

const Activity = lazy(
  () => import(/* webpackChunkName: "Activity" */ "./pages/Activity")
);

const ShareGame = lazy(
  () => import(/* webpackChunkName: "ShareGame" */ "./pages/ShareGame")
);

const Person = lazy(
  () => import(/* webpackChunkName: "Person" */ "./pages/Person")
);

// 用户留言
const Feedback = lazy(
  () => import(/* webpackChunkName: "Feedback" */ "./pages/Feedback")
);

// 用户留言 - 记录
const FeedbackLogs = lazy(
  () => import(/* webpackChunkName: "FeedbackLogs" */ "./pages/Feedback/Logs")
);

// 用户留言 - 详情
const FeedbackDetail = lazy(
  () =>
    import(/* webpackChunkName: "FeedbackDetail" */ "./pages/Feedback/Detail")
);

// 用户留言（无token版）
const FeedbackNoToken = lazy(
  () =>
    import(/* webpackChunkName: "FeedbackNoToken" */ "./pages/FeedbackNoToken")
);

// 用户留言（无token版） - 记录
const FeedbackNoTokenLogs = lazy(
  () =>
    import(
      /* webpackChunkName: "FeedbackNoTokenLogs" */ "./pages/FeedbackNoToken/Logs"
    )
);

// 用户留言（无token版） - 详情
const FeedbackNoTokenDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "FeedbackNoTokenDetail" */ "./pages/FeedbackNoToken/Detail"
    )
);

// 公众号用户留言
const MpFeedback = lazy(
  () => import(/* webpackChunkName: "FeedbackWX" */ "./pages/FeedbackMp")
);

// 公众号用户留言 - 登录
const MpFeedbackLogin = lazy(
  () =>
    import(/* webpackChunkName: "MpFeedbackLogin" */ "./pages/FeedbackMp/Login")
);

// 公众号用户留言 - 记录
const MpFeedbackLogs = lazy(
  () =>
    import(/* webpackChunkName: "MpFeedbackLogs" */ "./pages/FeedbackMp/Logs")
);

// 公众号用户留言 - 详情
const MpFeedbackDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "MpFeedbackDetail" */ "./pages/FeedbackMp/Detail"
    )
);

const Test = lazy(() => import(/* webpackChunkName: "Test" */ "./pages/Test"));

const App = () => {
  const position = (localStorage.getItem("position") || "bottom") as IPosition;

  return (
    <Router basename="/v19">
      <TabBar position={position}>
        <Suspense fallback={<PageLoading />}>
          <Switch>
            <Route
              exact
              path="/"
              component={() => <Redirect to="/account" />}
            />
            <Route exact path="/account" component={Account} />
            <Route exact path="/acaccount" component={ACAccount} />
            <Route exact path="/account3" component={Account3} />
            <Route exact path="/redpacket" component={Redpacket} />
            <Route exact path="/redpacket3" component={Redpacket3} />
            <Route exact path="/activity" component={Activity} />
            <Route exact path="/share" component={Share} />
            <Route exact path="/sharegame" component={ShareGame} />
            <Route exact path="/gift" component={Gift} />
            <Route exact path="/rank" component={Rank} />
            <Route exact path="/agreement" component={Agreement} />
            <Route exact path="/privacy" component={Privacy} />
            <Route exact path="/children" component={Children} />
            <Route exact path="/threeShare" component={ThreeShare} />
            <Route exact path="/person" component={Person} />
            <Route exact path="/more" component={More} />
            <Route exact path="/faq" component={Faq} />
            <Route exact path="/faq_feedback" component={FaqFeedback} />
            <Route exact path="/services" component={Services} />
            <Route exact path="/services/qiyu" component={ServicesQiyu} />
            <Route exact path="/feedback" component={Feedback} />
            <Route exact path="/feedback/logs" component={FeedbackLogs} />
            <Route exact path="/feedback/logs/:id" component={FeedbackDetail} />
            <Route exact path="/feedback_nt" component={FeedbackNoToken} />
            <Route
              exact
              path="/feedback_nt/logs"
              component={FeedbackNoTokenLogs}
            />
            <Route
              exact
              path="/feedback_nt/logs/:id"
              component={FeedbackNoTokenDetail}
            />
            <Route exact path="/community" component={Community} />
            <Route exact path="/test" component={Test} />
            <Route exact path="/feedback-mp" component={MpFeedback} />
            <Route
              exact
              path="/feedback-mp/login"
              component={MpFeedbackLogin}
            />
            <Route exact path="/feedback-mp/logs" component={MpFeedbackLogs} />
            <Route
              exact
              path="/feedback-mp/logs/:id"
              component={MpFeedbackDetail}
            />
          </Switch>
        </Suspense>
      </TabBar>
    </Router>
  );
};

export default App;
